import { Badge } from '@/components/ui/badge';

/**
 * ⚠ THE PLATFORM RETIRED THIS CONTROL, AND THE TENANT HAS TO BE TOLD.
 *
 * A retired control only reaches a tenant surface when they have ALREADY WORKED IT — the
 * go-forward catalogue stops offering retired controls, so anything retired that is still listed
 * carries the tenant's own evidence, assessments and assignments. That work is real and stays.
 *
 * ⚠ WHICH IS EXACTLY WHY IT NEEDS A MARKER. Keeping the row without saying why it is there shows
 * a withdrawn control as indistinguishable from a live one, and the tenant goes on working it —
 * collecting evidence for a control the catalogue no longer stands behind. The row is honest only
 * with the fact attached. Same shape as the catalogue-side bug: nothing displayed was FALSE, the
 * display was INCOMPLETE, and incomplete read as an assurance nobody gave.
 *
 * ⓘ Not an alarm. Retirement is not the tenant's failure and not a posture — it is a fact about
 * the CONTENT, so it is marked, not flagged. `rose` matches the admin catalogue's marker so the
 * same fact wears the same colour on both sides of the platform.
 */
export function RetiredMarker(
  { retiredAt, size = 'sm' }: { retiredAt: string | null | undefined; size?: 'sm' | 'md' },
) {
  if (!retiredAt) return null;

  // ⚠ The DATE is in the tooltip, never dropped. "Retired" alone invites "since when?", and the
  //    resolver carries a timestamp rather than a boolean precisely so this can answer it.
  const on = new Date(retiredAt).toLocaleDateString();
  return (
    <Badge
      variant="rose"
      data-testid="workspace-retired-marker"
      title={`Retired ${on} — no longer offered to new adopters. Your recorded work is kept.`}
      className={size === 'sm' ? 'shrink-0 px-[7px] py-0 text-[10px] font-medium' : 'shrink-0'}
    >
      retired
    </Badge>
  );
}
